export const tableV2HeaderHeight = '52px';
export const tableV2FooterHeight = '64px';
export const tableV2MinimumVisibleRows = 10;
export const tableV2BodyRowHeightPx = 80;
export const tableV2NestedHeaderHeight = '48px';
export const tableV2NestedBodyRowHeightPx = 72;
export const tableV2ChevronColumnWidth = '56px';
export const tableV2ChevronIconSize = '24px';
export const tableV2ChevronOffsetTransform = 'translate(calc(-50% - 2px), calc(-50% - 2px))';
export const tableV2SkeletonChevronOffsetTransform =
  'translate(calc(-50% + 2px), calc(-50% + 2px))';
export const tableV2ActionsColumnWidth = '48px';
export const tableV2NamePrimaryFontSize = '16px';
